import {Observable} from "rxjs/";
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {map} from "rxjs/operators";

@Injectable()
export class FixDataInterceptor implements HttpInterceptor {
  customFields = ['chartDesignSettings', 'dashboardDesignSettings', 'name', 'richName'];

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(this.modifyBody(request)).pipe(map((res: HttpEvent<any>) => {
      if (res instanceof HttpResponse) {
        res = this.modifyInData(res);
      }
      return res;
    }));
  }

  modifyBody(req: HttpRequest<any>): any {
    if (req.method.toLowerCase() === 'post') {
      req = this.modifyOutData(req)
    }
    return req;
  }

  private modifyInData(event: any): any {
    let eventBody = event?.body;
    if (eventBody && eventBody?.data) {
      eventBody = eventBody?.data;
      let hasChangedData = false;
      const newBody = {...eventBody};
      this.customFields.forEach(key=>{
        if (eventBody[key]) {
          hasChangedData = true;
            const designSettings = eventBody[key];
          newBody[key] = designSettings.replaceAll('tartStyle', 'style=');
        }
      });
      if(newBody?.charts && newBody?.charts?.length){
        newBody.charts.forEach((item:any)=>{
          if (item['chartDesignSettings']) {
            hasChangedData = true;
            const designSettings = item['chartDesignSettings'];
            item['chartDesignSettings'] = designSettings.replaceAll('tartStyle', 'style=');
          }
          if(item['name']) {
            hasChangedData = true;
            const designSettings = item['name'];
            item['name'] = designSettings.replaceAll('tartStyle', 'style=');
          }
        });
      }
      if(hasChangedData){
        event = event.clone({
          body: {data: {...newBody}}
        });
      }
    }
    return event;
  }

  private modifyOutData(event: any): any {
    if (event.body) {
      this.customFields.forEach(key=>{
        if (event.body[key])  {
          const designSettings = event.body[key];
          const parsedData = designSettings.replaceAll('style=', 'tartStyle');
          const newBody = {...event.body};
          newBody[key] = parsedData;
          event = event.clone({
            body: {...newBody}
          });
        }
      })
    }
    return event;
  }

}
